module.exports = __webpack_public_path__ + "img/hdsmrc.b5fbcd72.png";